import React, { Fragment } from "react";

import { withRouter } from "@wevideo/core/router/withRouter";

import { APP_EXTERNAL_URLS, APP_ROUTES } from "../../constants/AppGlobal";
import { getUserUserName, isAuth } from "../../helpers/AppHelper";
import { isLocalHost } from "../../helpers/GeneralHelper";
import URLHelper from "../../helpers/URLHelper";
import "./css/tester.scss";

class Tester extends React.Component<any, any> {
	[key: string]: any;
	static defaultProps: any;
	static propTypes: any;
	constructor(props) {
		super(props);
		let redirectUrl = APP_ROUTES.PLANS_PAGE;
		if (isLocalHost()) {
			redirectUrl =
				window.location.protocol +
				"//" +
				window.location.hostname +
				":" +
				window.location.port +
				redirectUrl;
		}
		this.state = {
			isLoggedIn: props.isLoggedIn,
			userName: props.userName,
			redirectURL: redirectUrl,
		};
	}
	componentDidMount() {
		this.setState({
			isLoggedIn: isAuth(),
			userName: getUserUserName(),
		});
	}
	componentDidUpdate(prevProps, prevState, _snapshot) {
		if (prevState.userName !== getUserUserName() || prevState.isLoggedIn !== isAuth()) {
			this.setState({
				isLoggedIn: isAuth(),
				userName: getUserUserName(),
			});
		}
	}
	handleMenuLinkClick = event => {
		event.preventDefault();
		event.stopPropagation();
		if (event.hasOwnProperty("target") && event.target instanceof HTMLAnchorElement) {
			const url = event.target.getAttribute("href");
			URLHelper.goTo(url);
		}
	};
	render() {
		return (
			<div className="tester-sidebar">
				{(this.props.companyName || this.props.pageName) && (
					<div className="tester-sidebar__header">
						{this.props.companyName}
						{" — "}
						{this.props.pageName}
					</div>
				)}

				<div className="tester-sidebar__auth">
					{this.state.isLoggedIn ? (
						<Fragment>
							<div className="tester-sidebar__user">{this.state.userName}</div>
							<a href={APP_EXTERNAL_URLS.LOG_OUT_URL}>Logout</a>
						</Fragment>
					) : (
						<a
							onClick={this.handleMenuLinkClick}
							href={APP_EXTERNAL_URLS.SIGN_IN + "?redirectURL=" + APP_EXTERNAL_URLS.HUB}
						>
							Login
						</a>
					)}
				</div>

				<ul className="tester-sidebar__nav">
					<li>
						<a onClick={this.handleMenuLinkClick} href={APP_ROUTES.HOMEPAGE}>
							Homepage
						</a>
					</li>
					{isAuth() ? (
						<li>
							<a onClick={this.handleMenuLinkClick} href={APP_ROUTES.PLANS_PAGE}>
								Plans
							</a>
						</li>
					) : (
						<li>
							<a onClick={this.handleMenuLinkClick} href={APP_EXTERNAL_URLS.NOT_LOGGED_PLANS_PAGE}>
								Pricing
							</a>
						</li>
					)}
					<li>
						<a onClick={this.handleMenuLinkClick} href={APP_ROUTES.INVITE_PAGE}>
							Invite
						</a>
					</li>
					<li>
						<a onClick={this.handleMenuLinkClick} href={APP_ROUTES.NEW_PASSWORD}>
							New Password
						</a>
					</li>

					{!this.state.isLoggedIn && (
						<Fragment>
							<li>
								<a
									onClick={this.handleMenuLinkClick}
									href={
										APP_EXTERNAL_URLS.SIGN_UP +
										"?tier=personal&redirectURL=" +
										this.state.redirectURL
									}
								>
									Sign up — personal
								</a>
							</li>
							<li>
								<a
									onClick={this.handleMenuLinkClick}
									href={
										APP_EXTERNAL_URLS.SIGN_UP +
										"?tier=business&redirectURL=" +
										this.state.redirectURL
									}
								>
									Sign up — business
								</a>
							</li>
							<li>
								<a
									onClick={this.handleMenuLinkClick}
									href={
										APP_EXTERNAL_URLS.SIGN_UP +
										"?tier=education&redirectURL=" +
										this.state.redirectURL
									}
								>
									Sign up — education
								</a>
							</li>
							<li>
								<a onClick={this.handleMenuLinkClick} href={APP_EXTERNAL_URLS.K12_STUDENT_SIGN_UP}>
									Sign up — K-12 Student
								</a>
							</li>
							<li>
								<a onClick={this.handleMenuLinkClick} href={APP_EXTERNAL_URLS.SIGN_UP}>
									New Sign up
								</a>
							</li>
						</Fragment>
					)}
				</ul>
			</div>
		);
	}
}

export default withRouter(Tester);
